import {useUsageEventQuery} from './useUsageEventsQuery';

// FNP-536: single-record read for the detail view. Read-only — no create, update, or
// delete (the FNP-215 ingestion writer owns the lifecycle).
export const useUsageEvent = (id?: string) => {

    const usageEventQuery = useUsageEventQuery(id);

    return {
        record: usageEventQuery.data,
        loading: usageEventQuery.isLoading,
        // A failed load and a missing record are different facts and the detail page says
        // which: "could not load" is not "does not exist".
        isError: usageEventQuery.isError,
        notFound: usageEventQuery.isFetched && !usageEventQuery.isError && !usageEventQuery.data,
        fetchRecord: usageEventQuery.refetch,
    };
};
